import * as types from '../actions/actionTypes';

const initialState = {
  loaderOpened: false,
  loaderTitle: "loader.defaultTitle",
  loaderText: "loader.defaultText",
  loaderFullScreen: false,
  multiLoader: {
    visible: true,
    activeStep: 0,
    renderSteps: [
      {icon: "doorStyle", text: "doorStyle"},
      {icon: "color", text: "color"},
      {icon: "layout", text: "layout"},
      {icon: "design1", text: "design1"},
      {icon: "4kOutput", text: "4kOutput"},
      {icon: "lighting", text: "lighting"},
      {icon: "design1", text: "design2"},
    ]
  }
};

export default function(state = initialState, action) {
  switch(action.type) {
    case types.TOGGLE_LOADER:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_MULTI_LOADER:
      return Object.assign({}, state, {
        multiLoader: {...state.multiLoader, ...action.payload}
      });

  }

  return state;
}
